import PropTypes from 'prop-types';

import {OEFeature} from '../../../react-oe/oe-types';
import {OEViewType} from '../../../lib/oe-types';
import OEMainMenuBtnAdapterView from './button-adapters/oe-main-menu-btn-adapter-view';
import OEIconCodes from '../../../lib/oe-icon-codes';

export const OEMainMenuStdBtnType = {
    home:               'home',
    label:              'label',
    note:               'note',
    arrow:              'arrow',
    userObject:         'userObject',
    cut:                'cut',
    search:             'search',
    tree:               'tree',
    substructure:       'substructure',
    color:              'color',
    explode:            'explode',
    presentation:       'presentation',
    mediaCenter:        'mediaCenter',
    screenshot:         'screenshot',
    info:               'info',
    infoHelp:           'infoHelp',
    help:               'help',
    startSelection:     'startSelection',
    settings:           'settings',
    secondarySettings:  'secondarySettings',
    offlineManager:     'offlineManager',
    back:               'back',
	forth:              'forth'
};

//
export const OEMainMenuStdBtnFeature = {
    label:              OEFeature.labels,
    note:               OEFeature.notes,
    arrow:              OEFeature.arrows,
    userObject:         OEFeature.user_objects,
    cut:                OEFeature.cut,
    search:             OEFeature.search,
    tree:               OEFeature.tree,
    substructure:       OEFeature.substructure,
    color:              OEFeature.color,
    explode:            OEFeature.explosion,
    presentation:       OEFeature.presentation,
    mediaCenter:        OEFeature.media,
    screenshot:         OEFeature.screenshot,
    back:               OEFeature.state_collection,
    forth:              OEFeature.state_collection,
};

//
export const OEMainMenuBtnLocation = {
    top:                'top',
    bottom:             'bottom',
    left:               'left',
    right:              'right'
};

//
export const OEMainMenuStdBtnLayouts = {
    std: function() {
        return {
            top: [
                OEMainMenuStdBtnType.startSelection,
                OEMainMenuStdBtnType.home,
                OEMainMenuStdBtnType.search,
                OEMainMenuStdBtnType.tree,
                OEMainMenuStdBtnType.label,
                OEMainMenuStdBtnType.note,
                OEMainMenuStdBtnType.arrow,
                OEMainMenuStdBtnType.userObject,
                OEMainMenuStdBtnType.cut,
                OEMainMenuStdBtnType.substructure,
                OEMainMenuStdBtnType.color,
                OEMainMenuStdBtnType.explode,
                OEMainMenuStdBtnType.presentation,
                OEMainMenuStdBtnType.mediaCenter,
                OEMainMenuStdBtnType.screenshot,
                OEMainMenuStdBtnType.info,
                OEMainMenuStdBtnType.infoHelp,
                OEMainMenuStdBtnType.help,
                OEMainMenuStdBtnType.settings,
                OEMainMenuStdBtnType.secondarySettings,
                OEMainMenuStdBtnType.offlineManager
            ],
            bottom: [OEMainMenuStdBtnType.back, OEMainMenuStdBtnType.forth],
            left: [],
            right: []
        };
    },

    stdWithLeftRight: function()   {
        return {
            top: [
                OEMainMenuStdBtnType.search,
                OEMainMenuStdBtnType.tree,
                OEMainMenuStdBtnType.label,
                OEMainMenuStdBtnType.note,
                OEMainMenuStdBtnType.arrow,
                OEMainMenuStdBtnType.userObject,
                OEMainMenuStdBtnType.cut,
                OEMainMenuStdBtnType.substructure,
                OEMainMenuStdBtnType.color,
                OEMainMenuStdBtnType.explode,
                OEMainMenuStdBtnType.presentation,
                OEMainMenuStdBtnType.mediaCenter,
                OEMainMenuStdBtnType.screenshot,
                OEMainMenuStdBtnType.settings,
            ],
            bottom: [],
            left: [OEMainMenuStdBtnType.home, OEMainMenuStdBtnType.back, OEMainMenuStdBtnType.forth, OEMainMenuStdBtnType.startSelection],
            right: [OEMainMenuStdBtnType.secondarySettings, OEMainMenuStdBtnType.info, OEMainMenuStdBtnType.infoHelp, OEMainMenuStdBtnType.help, OEMainMenuStdBtnType.offlineManager]
        };
    }
};

//
export class OEMainMenuBtnConfigFactory {

    constructor(buttons, ref = true) {
        this.set(buttons, ref);
    }

    set(buttons, ref = false)    {  // ref == true -> overwrite reference
        if(typeof(buttons) !== 'object' || buttons === null)    {
            if(!ref && this.buttons) {
                this.buttons.top = [];
                this.buttons.bottom = [];
                this.buttons.left = [];
                this.buttons.right = [];
            } else {
                this.buttons = {top: [], bottom: [], left: [], right: []};
            }
            return this;
        }

        if(ref) {
            this.buttons = buttons;
            if(!Array.isArray(this.buttons.top))    this.buttons.top = [];
            if(!Array.isArray(this.buttons.bottom))    this.buttons.bottom = [];
            if(!Array.isArray(this.buttons.left))    this.buttons.left = [];
            if(!Array.isArray(this.buttons.right))    this.buttons.right = [];
        } else {
            this.buttons.top = Array.isArray(buttons.top) ? buttons.top.map(e => e) : [];
            this.buttons.bottom = Array.isArray(buttons.bottom) ? buttons.bottom.map(e => e) : [];
            this.buttons.left = Array.isArray(buttons.left) ? buttons.left.map(e => e) : [];
            this.buttons.right = Array.isArray(buttons.right) ? buttons.right.map(e => e) : [];
        }

        return this;
    }

    build(copy = true)   {
        if(!copy)    return this.buttons;

        return {
            top: this.buttons.top.map(e => e),
            bottom: this.buttons.bottom.map(e => e),
            left: this.buttons.left.map(e => e),
            right: this.buttons.right.map(e => e),
        };
    }

    clear() {
        return this.set(undefined, false);
    }

    std(withLeftRight = false)   {
        return this.set(OEMainMenuBtnConfigFactory.buildStdButtons(withLeftRight), false);
    }

    replaceLocation(location, buttons)  {
        if(this.buttons[location] === undefined)    return this;
        buttons = OEMainMenuBtnConfigFactory.normalizeButton(buttons);
        this.buttons[location] = Array.isArray(buttons) ? buttons : (buttons === undefined ? [] : [buttons]);
    }

    hasButton(type, location)   {
        if(typeof(location) !== 'string')   {
            for(let i = 0; i < Object.keys(OEMainMenuBtnLocation).length; ++i)  {
                let location = OEMainMenuBtnLocation[Object.keys(OEMainMenuBtnLocation)[i]];
                if(this.hasButton(type, location))  return true;
            }
        }

        if(this.buttons[location] === undefined)    return false;

        let index = this.buttons[location].findIndex(btn => btn.type === type);
        return index >= 0;
    }

    insertButtonAtIndex(location, index, button)   {
        button = OEMainMenuBtnConfigFactory.normalizeButton(button);
        if(!button) return this;

        if(this.buttons[location] === undefined)    return this;

        if(!Array.isArray(button))   button = [button];
        this.buttons[location].splice(index, 0, ...button);

        return this;
    }

    addButton(location, button) {
        if(this.buttons[location] === undefined)    return this;

        return this.insertButtonAtIndex(location, this.buttons[location].length, button);
    }

    replaceButtonAtIndex(location, index, button)   {
        button = OEMainMenuBtnConfigFactory.normalizeButton(button);
        if(!button) return this;

        if(this.buttons[location] === undefined)    return this;

        if(!Array.isArray(button))   button = [button];
        this.buttons[location].splice(index, 1, ...button);
        return this;
    }

    insertButtonRelativeToType(type, offset, button, location)  {
        button = OEMainMenuBtnConfigFactory.normalizeButton(button);
        if(!button) return this;

        if(typeof(location) !== 'string')   {
            Object.keys(OEMainMenuBtnLocation).forEach(location => this.insertButtonRelativeToType(type, offset, button, location));
            return this;
        }
        if(this.buttons[location] === undefined)    return this;

        let index = this.buttons[location].findIndex(btn => btn.type === type);
        if(index < 0)   return this;
        
        if(!Array.isArray(button))   button = [button];
        this.buttons[location].splice(index + offset, 0, ...button);

        return this;
    }

    insertButtonAfterType(type, button, location) {
        return this.insertButtonRelativeToType(type, 1, button, location);
    }

    insertButtonInFrontOfType(type, button, location) {
        return this.insertButtonRelativeToType(type, 0, button, location);
    }

    replaceButtonByType(type, button, location) {
        button = OEMainMenuBtnConfigFactory.normalizeButton(button);
        if(!button) return this;

        if(typeof(location) !== 'string')   {
            Object.keys(OEMainMenuBtnLocation).forEach(location => this.replaceButtonByType(type, button, location));
            return this;
        }
        if(this.buttons[location] === undefined)    return this;

        let index = this.buttons[location].findIndex(btn => btn.type === type);
        if(index < 0)   return this;

        if(!Array.isArray(button))   button = [button];
        this.buttons[location].splice(index, 1, ...button);

        return this;
    }

    removeButtonByType(type, location)  {
        let types = Array.isArray(type) ? type : (typeof(type) == 'string' ? [type] : []);
        if(!types.length)   return this;

        if(typeof(location) !== 'string')   {
            Object.keys(OEMainMenuBtnLocation).forEach(location => this.removeButtonByType(types, location));
            return this;
        }
 
        if(this.buttons[location] === undefined)    return this;

        this.buttons[location] = this.buttons[location].filter(btn => !types.includes(btn.type));

        return this;
    }

    removeAllButtons(excludedType, location)  {
        let types = Array.isArray(excludedType) ? excludedType : (typeof(excludedType) == 'string' ? [excludedType] : []);

        if(typeof(location) !== 'string')   {
            Object.keys(OEMainMenuBtnLocation).forEach(location => this.removeAllButtons(types, location));
            return this;
        }
 
        if(this.buttons[location] === undefined)    return this;

        this.buttons[location] = this.buttons[location].filter(btn => excludedType.includes(btn.type));

        return this;
    }

    modifyButtonByType(type, fn, location)    {
        if(!fn) return this;

        if(typeof(location) !== 'string')   {
            Object.keys(OEMainMenuBtnLocation).forEach(location => this.modifyButtonByType(type, fn, location));
            return this;
        }

        if(this.buttons[location] === undefined)    return this;

        this.buttons[location].forEach(btn => {
            if(btn.type !== type)   return;
            fn(btn);
        });

        return this;
    }

    forEach(fn) {
        Object.keys(OEMainMenuBtnLocation).forEach(location => {
            if(this.buttons[location] === undefined)    return;
            this.buttons[location].forEach((btn, i) => { fn(btn, location, i); });
        });
        return this;
    }

    convertToLayout(layout) {
        this.forEach(btn => { delete btn._hasMatchInLayout; });

        let buttons = {
            top: layout.top.map(e => e),
            bottom: layout.bottom.map(e => e),
            left: layout.left.map(e => e),
            right: layout.right.map(e => e),
        };

        let matchFn = (sublayout, btn) => {
            let matchFound = false;
            let resLayout = sublayout.map(e => {
                if(matchFound || typeof(e) !== 'string')  return e;
                let matches = btn.type.startsWith(e);
                if(btn.type === OEMainMenuStdBtnType.infoHelp)  matches = btn.type == e;
                if(matches) matchFound = true;
                return matches ? btn : e;
            });

            if(matchFound)  btn._hasMatchInLayout = true;

            return {
                matchFound: matchFound,
                result: resLayout
            };
        };

        let insertFn = (btn) => {
            let res = matchFn(buttons.top, btn);
            buttons.top = res.result;
            if(res.matchFound)  return;
            res = matchFn(buttons.bottom, btn);
            buttons.bottom = res.result;
            if(res.matchFound)  return;
            res = matchFn(buttons.left, btn);
            buttons.left = res.result;
            if(res.matchFound)  return;
            res = matchFn(buttons.right, btn);
            buttons.right = res.result;
            if(res.matchFound)  return;
        };

        this.buttons.top.forEach(insertFn);
        this.buttons.bottom.forEach(insertFn);
        this.buttons.left.forEach(insertFn);
        this.buttons.right.forEach(insertFn);

        this.forEach((btn, location, i) => {
            if(!btn._hasMatchInLayout)     console.log('Warning - non matchable button at (' + location + ', ' + i.toString() +') while converting main menu layout.');
            delete btn._hasMatchInLayout;
        });

        this.buttons.top = buttons.top.filter(btn => typeof(btn) !== 'string');
        this.buttons.bottom = buttons.bottom.filter(btn => typeof(btn) !== 'string');
        this.buttons.left = buttons.left.filter(btn => typeof(btn) !== 'string');
        this.buttons.right = buttons.right.filter(btn => typeof(btn) !== 'string');

        return this;
    }

    convertToStdLayout(withLeftRight = false)   {
        return this.convertToLayout(withLeftRight ? OEMainMenuStdBtnLayouts.stdWithLeftRight() : OEMainMenuStdBtnLayouts.std());
    }
};

OEMainMenuBtnConfigFactory.buildStdButton = function()  {
    let buttons = {};
    Object.keys(OEMainMenuStdBtnType).forEach(key => {
        let value = OEMainMenuStdBtnType[key]; buttons[value] = {type: value, enabled: true};
    });

    return (type, enabled) => {
        let ret;
        if(type === OEMainMenuStdBtnType.screenshot)    {
            ret = {type: OEMainMenuStdBtnType.screenshot, enabled: true, adapter: new OEMainMenuBtnAdapterView(OEViewType.screenshot, null, OEFeature.screenshot)};
        } else if(type === OEMainMenuStdBtnType.infoHelp) {
            ret = {type: OEMainMenuStdBtnType.infoHelp, enabled: true, icon: OEIconCodes.info, adapter: new OEMainMenuBtnAdapterView(OEViewType.start, 'info-help')};
        } else if(type === OEMainMenuStdBtnType.help) {
            ret = {type: OEMainMenuStdBtnType.help, enabled: true, adapter: new OEMainMenuBtnAdapterView(OEViewType.help)};
        } else if(type === OEMainMenuStdBtnType.startSelection) {
            ret = {type: OEMainMenuStdBtnType.startSelection, enabled: true, adapter: new OEMainMenuBtnAdapterView(OEViewType.startSelection)};
        } else if(type === OEMainMenuStdBtnType.secondarySettings)    {
            ret = {type: OEMainMenuStdBtnType.secondarySettings, enabled: true, adapter: new OEMainMenuBtnAdapterView(OEViewType.secondarySettings)};
        } else if(type === OEMainMenuStdBtnType.offlineManager)    {
            ret = {type: OEMainMenuStdBtnType.offlineManager, enabled: true, adapter: new OEMainMenuBtnAdapterView(OEViewType.offlineManager)};
        } else {
            ret = Object.assign({}, buttons[type]);
        }
        if(typeof(enabled) === 'boolean')   ret.enabled = enabled;
        return ret;
    }
}();

OEMainMenuBtnConfigFactory.normalizeButton = function(button)  {
    if(Array.isArray(button))   return button.map(btn => OEMainMenuBtnConfigFactory.normalizeButton(btn)).filter(btn => btn !== undefined);

    if(typeof(button) === 'string') {
        return OEMainMenuBtnConfigFactory.buildStdButton(button);
    }

    if(typeof(button) === 'object' && button !== null)  {
        let ret = button;
        if(typeof(ret.enabled) !== 'boolean')   ret.enabled = true;
        return ret;
    }

    return undefined;
};

OEMainMenuBtnConfigFactory.mapToStdButtonFn = function(btn) {
    return typeof(btn) === 'string' ? OEMainMenuBtnConfigFactory.buildStdButton(btn) : btn;
};

OEMainMenuBtnConfigFactory.buildStdButtonArray = function(buttons)  {
    return buttons.map(OEMainMenuBtnConfigFactory.mapToStdButtonFn);
};

OEMainMenuBtnConfigFactory.buildStdTopButtons = function(withLeftRight = false)  {
    let Type = OEMainMenuStdBtnType;
    let buttons;
    if(!withLeftRight)   {
        buttons = [Type.home, Type.search, Type.tree, Type.label, Type.note, Type.arrow, Type.cut, Type.substructure, Type.color, Type.explode, Type.presentation, Type.mediaCenter, Type.screenshot, Type.info, Type.settings];
    } else {
        buttons = [Type.search, Type.tree, Type.label, Type.note, Type.arrow, Type.cut, Type.substructure, Type.color, Type.explode, Type.presentation, Type.mediaCenter, Type.screenshot, Type.settings];
    }
    return OEMainMenuBtnConfigFactory.buildStdButtonArray(buttons);
};

OEMainMenuBtnConfigFactory.buildStdBottomButtons = function(withLeftRight = false)  {
    let Type = OEMainMenuStdBtnType;
    let buttons;
    if(!withLeftRight)   {
        buttons = [Type.back, Type.forth];
    } else {
        buttons = [];
    }
    return OEMainMenuBtnConfigFactory.buildStdButtonArray(buttons);
};

OEMainMenuBtnConfigFactory.buildStdLeftButtons = function(withLeftRight = false)  {
    let Type = OEMainMenuStdBtnType;
    let buttons;
    if(!withLeftRight)   {
        buttons = [];
    } else {
        buttons = [Type.home, Type.back, Type.forth];
    }
    return OEMainMenuBtnConfigFactory.buildStdButtonArray(buttons);
};

OEMainMenuBtnConfigFactory.buildStdRightButtons = function(withLeftRight = false)  {
    let Type = OEMainMenuStdBtnType;
    let buttons;
    if(!withLeftRight)   {
        buttons = [];
    } else {
        buttons = [Type.info];
    }
    return OEMainMenuBtnConfigFactory.buildStdButtonArray(buttons);
};

OEMainMenuBtnConfigFactory.buildStdButtons = function(withLeftRight = false)  {
    return {
        top:            this.buildStdTopButtons(withLeftRight),
        bottom:         this.buildStdBottomButtons(withLeftRight),
        left:           this.buildStdLeftButtons(withLeftRight),
        right:          this.buildStdRightButtons(withLeftRight),
    };
};

//
export const OEMainMenuButtonPropType = PropTypes.shape({
    id:                 PropTypes.number,       // this id is only for identifying the button with state data in the callbacks for example, the DOM element id is inferred from the type, also see renderButton
    type:               PropTypes.string.isRequired,
    className:          PropTypes.string,
    enabled:            PropTypes.bool.isRequired,
    feature:            PropTypes.number,
    licensingAccess:    PropTypes.func,
    tooltip:            PropTypes.string,
    icon:               PropTypes.string,
    adapter:            PropTypes.object
});

export const OEMainMenuButtonsPropType = PropTypes.arrayOf(OEMainMenuButtonPropType);

